import React from "react";

export function StatCard({ label, value, hint, accent = false, testId }) {
  return (
    <div
      data-testid={testId}
      className="bg-white border border-slate-200 rounded-xl p-5 hover:shadow-sm transition-shadow"
    >
      <div className="text-[11px] font-semibold uppercase tracking-widest text-slate-500">
        {label}
      </div>
      <div className={"mt-2 font-display text-3xl font-bold tracking-tight " + (accent ? "text-[#ab0000]" : "text-slate-900")}>
        {value}
      </div>
      {hint && <div className="mt-1 text-xs text-slate-500">{hint}</div>}
    </div>
  );
}

export function Section({ title, action, children, className = "" }) {
  return (
    <section className={"bg-white border border-slate-200 rounded-xl " + className}>
      <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
        <h3 className="font-display text-base font-semibold tracking-tight text-slate-900">{title}</h3>
        {action}
      </div>
      <div className="p-5">{children}</div>
    </section>
  );
}

export function StatusBadge({ status }) {
  const map = {
    New: "bg-blue-50 text-blue-700 border-blue-200",
    Quoted: "bg-amber-50 text-amber-700 border-amber-200",
    Negotiation: "bg-purple-50 text-purple-700 border-purple-200",
    Won: "bg-emerald-50 text-emerald-700 border-emerald-200",
    Lost: "bg-slate-100 text-slate-600 border-slate-200",
    "On Hold": "bg-slate-100 text-slate-600 border-slate-200",
    Sent: "bg-blue-50 text-blue-700 border-blue-200",
    Draft: "bg-slate-100 text-slate-600 border-slate-200",
    Expired: "bg-slate-100 text-slate-600 border-slate-200",
    High: "bg-[#fce8e8] text-[#ab0000] border-[#f5c2c2]",
    Medium: "bg-amber-50 text-amber-700 border-amber-200",
    Low: "bg-slate-100 text-slate-600 border-slate-200",
  };
  const cls = map[status] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span className={"inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border " + cls}>
      {status}
    </span>
  );
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="text-center py-12">
      {Icon && (
        <div className="w-12 h-12 rounded-full bg-slate-100 grid place-items-center mx-auto mb-3">
          <Icon size={20} className="text-slate-400" />
        </div>
      )}
      <div className="font-display text-base font-semibold text-slate-900">{title}</div>
      {description && <div className="text-sm text-slate-500 mt-1">{description}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 sm:gap-4 mb-5 sm:mb-6">
      <div className="min-w-0">
        <h2 data-testid="page-title" className="font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-900">{title}</h2>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
